export const searchIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                    <g>
                        <g>
                            <g>
                                <path d="M0 0H24V24H0z" transform="translate(-387 -191) translate(363 171) translate(24 20)"/>
                                <g stroke="#5F6368" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" transform="translate(-387 -191) translate(363 171) translate(24 20) translate(3 3)">
                                    <circle cx="8" cy="8" r="8"/>
                                    <path d="M18 18L13.65 13.65"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>`;
